// Dessert data
const desserts = [
  {
    id: 1,
    name: 'New York Cheesecake',
    description: 'Authentic New York style cheesecake with a graham cracker crust. Rich, creamy, and simply delicious.',
    price: '$6.99',
    icon: 'cheese'
  },
  {
    id: 2,
    name: 'Chocolate Chip Cookies',
    description: 'Fresh baked cookies with semi-sweet chocolate chips. Sold individually or by the dozen.',
    price: '$1.99 each',
    icon: 'cookie'
  },
  {
    id: 3,
    name: 'Black & White Cookie',
    description: 'Classic New York style half chocolate, half vanilla iced cookies. Soft and cake-like.',
    price: '$3.99 each',
    icon: 'cookie'
  },
  {
    id: 4,
    name: 'Rugelach',
    description: 'Traditional Jewish pastries filled with cinnamon, nuts, chocolate, or fruit preserves.',
    price: '$9.99 (6 pc)',
    icon: 'cake'
  },
  {
    id: 5,
    name: 'Apple Strudel',
    description: 'Flaky pastry filled with spiced apples, raisins, and walnuts. Served warm with a dusting of powdered sugar.',
    price: '$5.99',
    icon: 'apple'
  },
  {
    id: 6,
    name: 'Chocolate Layer Cake',
    description: 'Decadent chocolate cake with rich chocolate frosting between each layer.',
    price: '$6.99',
    icon: 'birthdayCake'
  }
];

export default desserts;
